if (!customElements.get('apella-key-highlights')) {
  customElements.define(
    'apella-key-highlights',
    class ApellaKeyHighlights extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-apella-key-highlights-panel]');
        this.toggle = this.querySelector('[data-apella-key-highlights-toggle]');
        this.galleryItem = this.closest('[data-media-id]');
        this.viewer = this.closest('slider-component');
        this.manualCollapsed = false;

        if (!this.panel || !this.toggle || !this.galleryItem || !this.viewer) return;

        this.onToggle = this.onToggle.bind(this);
        this.onPointerInteraction = this.onPointerInteraction.bind(this);
        this.onSlideChanged = this.onSlideChanged.bind(this);
        this.toggle.addEventListener('click', this.onToggle);
        this.toggle.addEventListener('pointerdown', this.onPointerInteraction);
        this.toggle.addEventListener('pointerup', this.onPointerInteraction);
        this.viewer.addEventListener('slideChanged', this.onSlideChanged);
        this.setAttribute('data-apella-key-highlights-ready', '');

        requestAnimationFrame(() => {
          this.setActive(this.galleryItem.classList.contains('is-active'));
        });
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.toggle?.removeEventListener('pointerdown', this.onPointerInteraction);
        this.toggle?.removeEventListener('pointerup', this.onPointerInteraction);
        this.viewer?.removeEventListener('slideChanged', this.onSlideChanged);
      }

      onPointerInteraction(event) {
        event.stopPropagation();
      }

      onToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
        this.manualCollapsed = expanded;
        this.setExpanded(!expanded);
        this.toggle.blur();
      }

      onSlideChanged(event) {
        this.setActive(event.detail.currentElement === this.galleryItem);
      }

      setActive(active) {
        this.classList.toggle('is-active', active);
        if (active && !this.manualCollapsed) this.setExpanded(true);
      }

      setExpanded(expanded) {
        this.classList.toggle('is-collapsed', !expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.toggle.setAttribute('aria-label', expanded ? 'Hide Key Highlights' : 'Show Key Highlights');
      }
    }
  );
}
